import { v4 as uuidv4 } from 'uuid';
import { ComponentType, type IFormFieldSchema } from '../../types';
import { JsonFieldType } from '../../../types';
import type { CheckboxProps } from 'antd';

export const generate = (
  props?: Partial<IFormFieldSchema<CheckboxProps>>
): IFormFieldSchema<CheckboxProps> => {
  const id = uuidv4();

  return {
    type: JsonFieldType.BOOLEAN,
    name: props?.name || id,
    title: props?.title || 'Checkbox',
    'x-designable-id': id,
    'x-index': props?.['x-index'] || 0,
    'x-decorator': 'FormItem',
    'x-component': ComponentType.FormCheckbox,
    'x-validator': [],
    'x-component-props': {},
    'x-component-props-config': {},
    'x-decorator-props': {},
    'x-decorator-props-config': {},
  };
};
